import ingredientGroups from './ingredientGroupsSlice';

export * from './thunks';

export default ingredientGroups;
